import {
  Box,
  Button,
  ButtonGroup
} from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import React from "react";
import TRANSACTION_STATE from "./state/TransactionState";

function SwitchMode(props) {
  const { mode } = props;
  return (
    <Box px={2}>
      <ButtonGroup variant="contained">
        <Button
          sx={{
            backgroundColor:
              mode.Value == TRANSACTION_STATE.PAYMENT ? blue[700] : grey[300],
            color: mode.Value == TRANSACTION_STATE.PAYMENT ? "white" : "black",
          }}
          onClick={() => mode.setValue(TRANSACTION_STATE.PAYMENT)}
        >
          出金
        </Button>
        <Button
          sx={{
            backgroundColor:
              mode.Value == TRANSACTION_STATE.RECEIPT ? blue[700] : grey[300],
            color: mode.Value == TRANSACTION_STATE.RECEIPT ? "white" : "black",
          }}
          onClick={() => mode.setValue(TRANSACTION_STATE.RECEIPT)}
        >
          入金
        </Button>
      </ButtonGroup>
    </Box>
  );
}

export default SwitchMode;
